var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"message-type"},[_vm._v(" "+_vm._s(_vm.getMessageType(_vm.message.messageType))+" "),_c('i',{class:{
      'fa fa-clock-o': _vm.message.timeout > 0,
      'fa fa-hand-pointer-o': _vm.message.timeout < 0
    },attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.getMessageTimeout(_vm.message))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }